import { useTranslation } from 'react-i18next'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

export const useAddBookingValidationSchema = () => {
	const { t } = useTranslation()

	const addBookingValidationSchema = yup.object({
		user: yup.object({
			value: yup.string().required(t('User is required'))
		}),
		rental: yup.object({
			value: yup.string().required(t('Rental is required'))
		}),
		booth: yup.object({
			value: yup.string().required(t('Area is required'))
		}),
		commission: yup
			.number()
			.typeError(t('Commission is required'))
			.required(t('Commission is required'))
			.min(0, t('Commission cannot be negative'))
	})

	return yupResolver(addBookingValidationSchema)
}
